import { makeAutoObservable, runInAction } from 'mobx'
import { type ISetting } from 'entities/Settings/api/types'
import { SettingsApi } from 'entities/Settings/api/settings'

export class OrganizationSettingsStore {
  initPromise
  private _setFinishInit: ((value?: unknown) => void) | null = null
  private _settingsMap: Map<ISetting['key'], ISetting> = new Map()
  private _settingsLoading = false

  constructor() {
    makeAutoObservable(this)

    this.initPromise = new Promise((resolve) => {
      this._setFinishInit = resolve
    })
  }

  fetchOrganizationSettings = async () => {
    try {
      runInAction(() => {
        this._settingsLoading = true
      })

      const { data } = await SettingsApi.getOrganizationSettings()

      runInAction(() => {
        data.forEach((item) => {
          this._settingsMap.set(item.key, item)
        })
      })
    } catch (e) {
      console.log(e)
    } finally {
      runInAction(() => {
        this._settingsLoading = false
        this._setFinishInit?.()
      })
    }
  }

  getItem = (key: string) => {
    return this._settingsMap.get(key)
  }

  get settings10DLC() {
    return this._settingsMap.get('10dlc_banners')
  }

  get hasTenDLCLimits() {
    return Boolean(this._settingsMap.get('compliance-functionality')?.settings.active)
  }

  get hasPublicApiClient() {
    return Boolean(this._settingsMap.get('public-api-client')?.settings.active)
  }
}
